import { render, staticRenderFns } from "./client-empty-state.vue?vue&type=template&id=17b39315&scoped=true&"
import script from "./client-empty-state.vue?vue&type=script&lang=js&"
export * from "./client-empty-state.vue?vue&type=script&lang=js&"
import style0 from "./client-empty-state.vue?vue&type=style&index=0&id=17b39315&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b39315",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b39315')) {
      api.createRecord('17b39315', component.options)
    } else {
      api.reload('17b39315', component.options)
    }
    module.hot.accept("./client-empty-state.vue?vue&type=template&id=17b39315&scoped=true&", function () {
      api.rerender('17b39315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/client-empty-state/client-empty-state.vue"
export default component.exports